<template>
  <v-layout row align-content-space-between align-center justify-space-between class="shift-item">
    <v-flex :shrink="!wide" :mr-2="!wide">
      <v-layout row align-content-start align-center>
        <v-flex v-if="this.showIcon" class="icon" shrink>
          <v-icon>person</v-icon>
        </v-flex>
        <v-flex class="shift-details" v-bind:class="{ smaller: smaller }">
          <div class="body-2">
            {{ itemData.startDatetime | moment("dddd, MMMM DD") }}
          </div>
          <div>
            <router-link :to="{ name: 'shiftDetail', params: { shiftId: itemData.id } }" class="unstyled-link">
              <span class="title" :class="itemData.workerName ? 'green--text' : 'red--text'">
                {{ itemData.shiftRole }}
              </span>
            </router-link>
            <div class="subtle body-2">
              {{ itemData.startDatetime | moment("h:mma") }} -
              {{ itemData.endDatetime | moment("h:mma") }}
            </div>
            <div v-if="itemData.workerName" class="title subtle">
              <EmployeeName
                :name="itemData.workerName"
                :employeeId="itemData.userId"
                :link="user.clientOrHigher"
              />
            </div>
          </div>
          <div class="subtle body-2">
            <router-link :to="{ name: 'shiftDetail', params: { shiftId: itemData.id } }" style="color: inherit;">
              {{ itemData.location }}
            </router-link>
          </div>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex shrink>
      <div>
        <v-layout row v-if="this.pickupable">

          <v-dialog v-model="pickUpDialog" max-width="290">
            <v-btn
              slot='activator'
              color='success'
              small
            >
              <v-icon left>
                add
              </v-icon>
              Pick Up
            </v-btn>
            <v-card>
              <v-card-title class="headline">Pick Up Shift?</v-card-title>
              <v-card-text>
                <p>
                  {{ itemData.shiftRole }}
                  at {{ itemData.location }}
                  on {{ itemData.startDatetime | moment("dddd, MMM Do [at] h:mma") }}

                  <BonusList :shift="itemData" :role="user.role" />
                </p>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey" flat @click="pickUpDialog = false">Nevermind</v-btn>
                <v-btn color='success' small :loading="apiCallPending" @click="pickUp">
                  Yes, I'll take it!
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

        </v-layout>

        <v-layout row justify-center>
          <BonusView :shift="itemData" type="travel" :role="user.role" />
          <BonusView :shift="itemData" type="callIn" :role="user.role" />
          <BonusView :shift="itemData" type="straight" :role="user.role" />
        </v-layout>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'
import BonusView from '@/components/shifts/bonus-view.vue'

export default {
  components: {
    BonusView
  },
  props: {
    showIcon: Boolean,
    smaller: Boolean,
    pickupable: Boolean,
    wide: Boolean,
    itemData: Object,
    shift: Object
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
  },
  methods: {
    pickUp () {
      this.apiCallPending = true
      this.$store.dispatch('shifts/pickUp', {
        shiftId: this.itemData.id,
        userId: this.user.id
      }).finally(res => {
        this.apiCallPending = false
        this.pickUpDialog = false
      })
    },
  },
  data: function () {
    return {
      pickUpDialog: false,
      apiCallPending: false
    }
  },
}
</script>

<style scoped>
/* .shift-item {
  min-width: 350px;
} */

.icon {
  display: inline-block;
}
.shift-details-icon {
  cursor: default;
}

.shift-details {
  display: inline-block;
}

.smaller {
  font-size: 0.8em;
}

.smaller-icon {
  font-size: 0.9em;
}
.shift-item {
  margin-bottom: 1rem;
}
</style>
